<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <span style="font-weight: 700" class="text-uppercase">Markierung {{ index + 1 }}</span>
      <div style="float:right">
        <button class="btn btn-sm btn-default" style="float:right; border: 0" @click="removeProductMark"
                content="Beitragserweiterung löschen" v-tippy>
          <i class="fa fa-close" style="color: black"></i>
        </button>
      </div>
    </div>
    <div class="panel-body">
      <label>Überschrift</label>
      <a class="fa fa-question-circle" v-tippy
         content="Maximal 20 Zeichen erlaubt."></a>
      <input class="form-control" type="text" maxlength="20" v-model="productMark.title">
      <br>
      <label>Untertext</label>
      <a class="fa fa-question-circle" v-tippy
         content="Maximal 20 Zeichen erlaubt."></a>
      <input class="form-control" type="text" maxlength="20" v-model="productMark.text">
      <br>
      <label>Bild</label>
      <a class="fa fa-question-circle" v-tippy content="Das empfohlene Bildmaß liegt im Seitenverhältnis 9:4 oder bei 557x557."></a>
      <content-preview-product-mark :product-mark="productMark"
                                    @update:channels="channelsUpdated"></content-preview-product-mark>
      <br>
      <div class="form-group">
        <input type="checkbox" id="use_button" v-model="productMark.use_button">
        <label for="use_button">Button hinzufügen</label>
      </div>
      <div v-if="productMark.use_button">
        <label>Button Text</label>
        <input class="form-control" type="text" maxlength="20" v-model="productMark.button_text">
        <br>
        <label>Verlinkung</label>
        <br>
        <select class="form-control" v-model="productMark.link_type"
                required>
          <option value="internal">Verlinkung innerhalb der App</option>
          <option value="external">Externe Verlinkung außerhalb der App</option>
          <option value="mail">E-Mail verschicken</option>
          <option value="call">Anruf</option>
        </select>
        <br>
        <div v-if="productMark.link_type === 'internal'">
          <label>Interne Verlinkung</label>
          <select v-model="productMark.link_internal" class="form-control"
                  style="margin-top: 5px">
            <option v-for="key in Object.keys(internalLinks)" :value="key" :key="key">{{ internalLinks[key] }}</option>
          </select>
          <div v-if="productMark.link_internal === 'PersonalShoppingModule'">
            <label for="">Berater (optional)</label>
            <a class="fa fa-question-circle" v-tippy
               content="Der Link führt direkt zum ausgewählten Berater in der App. Verfügbar ab App-Version 4.3."></a>
            <select v-model="productMark.atom_id" class="form-control">
              <option :value="null" selected>Bitte wählen</option>
              <option v-for="consultant in record.client.consultants" :value="consultant.id" :key="consultant.id">{{consultant.name}}</option>
            </select>
          </div>
          </div>
        <div v-if="productMark.link_type === 'external'">
          <label>Externe Verlinkung</label>
          <input class="form-control" type="text" v-model="productMark.link_external">
        </div>
        <div v-if="productMark.link_type === 'mail'">
          <label>E-Mailadresse</label>
          <input class="form-control" type="text" v-model="productMark.link_external">
        </div>
        <div v-if="productMark.link_type === 'call'">
          <label>Telefonnummer</label>
          <input class="form-control" type="text" v-model="productMark.link_external">
        </div>
        <br>
      </div>
      <br>
      <button class="btn btn-success" @click="resetPosition">Position zurücksetzen</button>
      <br>
    </div>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import ContentPreviewProductMark from "../image/ContentPreviewProductMark.vue";
import {mapGetters} from "vuex";

export default {
  name: 'MagazineProductMark',
  components: {ContentPreviewProductMark, VueToastr},
  computed: {
    ...mapGetters({
      internalLinks: 'getInternalLinks',
      record: 'getRecord',
    }),
  },
  props: ['context', 'selections', 'productMark', 'additionalContent', 'index'],
  methods: {
    removeProductMark(){
      this.additionalContent.product_marks.splice(this.index, 1);
    },
    channelsUpdated() {
      this.$parent.$forceUpdate()
    },
    resetPosition() {
      if (this.additionalContent.metadata) {
        this.productMark.x = this.additionalContent.metadata.computedWidth * 0.5;
        this.productMark.y = this.additionalContent.metadata.computedHeight * 0.5;
      } else {
        this.productMark.x = 200;
        this.productMark.y = 200;
      }
      this.productMark.relative_x = 0.5;
      this.productMark.relative_y = 0.5;
    }
  },
}
</script>

<style scoped>
.flex-column {
  display: flex;
  flex-direction: column;
}
</style>
<style>
.ckeditor-wrapper-app .ck-content {
  min-height: 100px;
}
</style>
